import React from "react";
import CreditCalculator from "./CreditCalculator";

function LoanInstallmentCalculator(props) {

    const calculationEndPoints = {
        calculatorUrl: "/loan/calculate",
        allowedCalculationParametersUrl: "/loan/allowed-calculation-parameters/?priceNet="
            + props.offer.minimumPriceGross + "&manufactureYear=" + props.offer.manufactureYear
    };

    return (
        <CreditCalculator
            {...props}
            {...calculationEndPoints}
            extraCalculationParams={{
                subjectName: "samochód osobowy",
                subjectAge: new Date().getFullYear() - props.offer.manufactureYear,
                productionYear: undefined
            }}

            periodLabel="Okres pożyczki (ilość miesięcznych rat)"
            hideRrso={true}
        />
    );
}

export default LoanInstallmentCalculator;
